@if (app.RM.fromRMSearch) {
  <div class="row py-3">
    <div class="col-8">
      <button
        class="btn btn-sm"
        (click)="switchView('tree')"
        [ngClass]="{ 'btn-default-blue': app.RM.mode === 'tree' }"
        >
        <i class="fas fa-sitemap"></i>&nbsp;&nbsp;{{ app.text.RM.treeView }}
      </button>
      <button
        class="btn btn-sm"
        (click)="switchView('all-manufacturers')"
      [ngClass]="{
        'btn-default-blue': app.RM.mode === 'all-manufacturers'
      }"
        >
        <i class="fal fa-table"></i>&nbsp;&nbsp;{{ app.text.RM.table }}
      </button>
      <button
        class="btn btn-sm"
        (click)="switchView('matched')"
        [ngClass]="{ 'btn-default-blue': app.RM.mode === 'matched' }"
        >
        <i class="far fa-link"></i>&nbsp;&nbsp;{{ app.text.RM.matched }}
      </button>
      <button
        class="btn btn-sm"
        (click)="switchView('unmatched')"
      [ngClass]="{
        'btn-default-blue': app.RM.mode === 'unmatched'
      }"
        >
        <i class="far fa-unlink"></i>&nbsp;&nbsp;{{ app.text.RM.unmatched }}
      </button>
      <button
        class="btn btn-sm"
        (click)="switchView('manual')"
        [ngClass]="{ 'btn-default-blue': app.RM.mode === 'manual' }"
        >
        <i class="fa fa-user-circle"></i>&nbsp;&nbsp;{{ app.text.RM.manual }}
      </button>
      <button
        class="btn btn-sm"
        (click)="switchView('manualAssignment')"
      [ngClass]="{
        'btn-default-blue': app.RM.mode === 'manualAssignment'
      }"
        >
        <i class="fas fa-user-edit"></i>&nbsp;&nbsp;{{
        app.text.matchingManufacturer.edited
        }}
      </button>
      <button
        class="btn btn-sm"
        (click)="switchView('override')"
      [ngClass]="{
        'btn-default-blue': app.RM.mode === 'override'
      }"
        >
        <i class="far fa-hand-paper"></i>&nbsp;&nbsp;{{ app.text.RM.override }}
      </button>
      @if (engineeringEnabled) {
        <button
          class="btn btn-sm"
          (click)="switchView('engineering')"
          [ngClass]="{ 'btn-default-blue': app.RM.mode === 'engineering' }"
          >
          <i class="fab fa-dev"></i>&nbsp;&nbsp;{{ app.text.RM.engineering }}
        </button>
      }
      @if (proactiveItemsEnabled) {
        <button
          class="btn btn-sm"
          (click)="switchView('proactiveItems')"
          [ngClass]="{ 'btn-default-blue': app.RM.mode === 'proactiveItems' }"
          >
          <i class="fas fa-bolt"></i>&nbsp;&nbsp;{{ app.text.RM.proactiveItems }}
        </button>
      }
    </div>
    <div class="col-4">
      <div class="d-flex justify-content-end">
        <div>
          @if (app.RM.mode === 'engineering' && app.permission.RM.canExport) {
            <button
              class="btn btn-sm btn-clean"
              (click)="app.RM.export('part', 'engineeringItems')"
              [ngbTooltip]="app.text.RM.proactiveReportEngineering"
              >
              <i class="fa fa-download"></i>&nbsp;
              {{ app.text.RM.proactiveReportEngineering }}
            </button>
          }
          @if (isManufacturerView && app.permission.RM.canExport) {
            <button
              class="btn btn-sm btn-clean"
              (click)="app.RM.export('manufacturer')"
              [ngbTooltip]="app.text.home.export"
              >
              <i class="fa fa-download"></i>&nbsp;
              {{ app.text.manufacturer.export }}
            </button>
          }
          @if (
            isManufacturerView &&
            app.permission.RM.canExport &&
            customExportEnabled
            ) {
            <button
              class="btn btn-sm btn-clean"
              (click)="app.RM.export('manufacturer', 'custom')"
              [ngbTooltip]="app.text.manufacturer.customExport"
              >
              <i class="fa fa-download"></i>&nbsp;
              {{ app.text.manufacturer.customExport }}
            </button>
          }
          @if (isManufacturerView) {
            <button
              class="btn btn-sm btn-clean"
              (click)="app.RM.export('manufacturer', 'substances')"
              [ngbTooltip]="app.text.RM.exportReach"
              >
              <i class="fas fa-flask"></i>&nbsp;
              {{ app.text.RM.exportReach }}
            </button>
          }
          @if (
            app.RM.mode === 'proactiveItems' && app.permission.RM.canExport
            ) {
            <button
              class="btn btn-sm btn-clean"
              (click)="app.RM.export('part', 'proactiveItems')"
              [ngbTooltip]="app.text.RM.clientReport"
              >
              <i class="fa fa-download"></i>&nbsp;
              {{ app.text.RM.clientReport }}
            </button>
          }
        </div>
        @if (app.type === 'part' && app.RM.mode === 'tree') {
          <div>
            <button
              class="btn btn-sm btn-default-blue"
              data-toggle="collapse"
              data-target="#collapseFilter"
              (click)="app.RM.filterOpen = !app.RM.filterOpen"
              [ngClass]="{ btnRMFilterOpen: app.RM.filterOpen }"
              >
              <i class="fas fa-filter"></i>
              {{ app.text.home.filters }}
              @if (!app.RM.filterOpen) {
                <i class="fal fa-angle-right"></i>
              }
              @if (app.RM.filterOpen) {
                <i class="far fa-times ml-1"></i>
              }
            </button>
          </div>
        }
      </div>
    </div>
  </div>
}
@if (app.RM.fromRMSearch) {
  <div>
    <div class="descriptionList">
      <div class="flex">
        <b>{{ app.field.getLabel(app.fieldId.part.partNumber) }}: &nbsp;</b>
        <span>{{ app.filterTree.highestLevel.partNumber }}</span>
      </div>
      <div class="flex">
        <b> {{ app.field.getLabel(app.fieldId.part.description) }}: &nbsp;</b>
        <span> {{ app.filterTree.highestLevel.description }} </span>
      </div>
    </div>
  </div>
}

<ngx-spinner
  name="tree"
  size="large"
  type="cog"
  bdColor="rgba(0, 0, 0, 0.5)"
  [fullScreen]="true"
  >
  <p class="tree-spinner-text">{{ app.text.app.loadingTreeRows }}</p>
</ngx-spinner>
<div>
  @switch (app.RM.mode) {
    @default {
      <div>
        <app-manufacturers-filter-table></app-manufacturers-filter-table>
      </div>
    }
    @case ('proactiveItems') {
      <div>
        <app-parts-filter-table></app-parts-filter-table>
      </div>
    }
    @case ('engineering') {
      <div>
        <app-parts-filter-table></app-parts-filter-table>
      </div>
    }
    @case ('tree') {
      <div>
        <app-paginator
          [length]="app.tree.pages"
          [index]="app.paginator.focus"
          (focus)="app.paginator.focus = $event"
          [type]="'rm-tree'"
          >
        </app-paginator>
        <rm-submenu
          class="tree-rm-section-tabs"
          [sections]="treeSections"
        ></rm-submenu>
        <!-- <div class="tree-legend" role="group" [attr.aria-label]="app.text.RM.treeView">
        <span class="tree-legend-item">
          <i class="fas fa-cube cpn-tree-icon cpn-tree-icon-assembly" aria-hidden="true"></i>
          <span>{{ app.field.getOptionText(app.fieldId.part.level, 'assembly') }}</span>
        </span>
        <span class="tree-legend-item">
          <i class="fas fa-cog cpn-tree-icon cpn-tree-icon-part" aria-hidden="true"></i>
          <span>{{ app.field.getOptionText(app.fieldId.part.level, 'part') }}</span>
        </span>
        <span class="tree-legend-item">
          <i class="fas fa-building cpn-tree-icon cpn-tree-icon-manufacturer" aria-hidden="true"></i>
          <span>{{ app.text.manufacturer.manufacturer }}</span>
        </span>
      </div> -->
      <div>
        <div
          class="p-1 tableFixHead table-responsive"
          (scroll)="onTreeScroll($event)"
          >
          <table class="table table-font-size table-striped spacing-table">
            <thead>
              <tr>
                @for (column of app.tree.currentColumns; track column) {
                  <th
                    class="p-1"
                    [ngClass]="app.tree.getHeaderStyle(column)"
                    [title]="app.table.setHeaderTooltip(column)"
                    >
                    <div
                  [ngClass]="{
                    'resize-table': app.table.canColumnBeResized(column)
                  }"
                      >
                      <span
                        [innerHtml]="app.field.handleSpecialLogicLabels(column)"
                      ></span>
                    </div>
                  </th>
                }
              </tr>
            </thead>
            <tbody>
              <tr>
                @if (loading) {
                  <td colspan="99" class="text-center">
                    {{ this.app.text.core.loading }}
                  </td>
                }
              </tr>
              <tr>
                @if (!app.tree.loading && app.tree.items.length === 0) {
                  <td
                    colspan="99"
                    class="text-center"
                    >
                    {{ app.text.app.noResults }}
                  </td>
                }
              </tr>
              @if (treeTopSpacerHeight > 0) {
                <tr
                  class="treeSpacer"
                  [style.height.px]="treeTopSpacerHeight"
                  >
                  <td colspan="99"></td>
                </tr>
              }
              @for (
                row of visibleTreeItems; track trackTreeRow(i,
                row); let i = $index) {
                <tr
                  class="treeRow"
                  [ngClass]="{ manufacturerRow: app.tree.isManufacturerRow(row) }"
                  >
                  @if (!app.tree.isManufacturerRow(row) || !displayMessage(row)) {
                    <app-tree-row
                      [row]="row"
                      [columns]="app.tree.currentColumns"
                      [index]="getTreeRowIndex(i)"
                      style="display: contents"
                    ></app-tree-row>
                  }
                  <!-- Display message in a tree row if there are no manufacturers under a part-->
                  @if (displayMessage(row)) {
                    <td
                      class="manufacturerRow"
                      colspan="99"
                      >
                      <span class="m-5">
                        {{ app.text.manufacturer.noManufacturer }}
                      </span>
                    </td>
                  }
                  <!-- <td *ngFor="let column of columns" class="p-1">
                  <span
                  *ngIf="
                    !app.tree.isManufacturerRow(row) || !displayMessage(row)
                  "
                    >
                    <app-tree-cell [row]="row" [column]="column"></app-tree-cell>
                  </span>
                </td> -->
              </tr>
            }
            @if (treeBottomSpacerHeight > 0) {
              <tr
                class="treeSpacer"
                [style.height.px]="treeBottomSpacerHeight"
                >
                <td colspan="99"></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
}
}
</div>
